/**
 * Distribución actual por estado (GI mapeado o etapa Kommo cruda).
 * @module-isolated analytics-cohort
 */
export default function StateDistribution({
  rows,
  total,
  selectedId,
  onSelect,
  title = 'Estado actual',
  note = 'Dónde están HOY estos leads en Kommo · no es cómo estaban al cierre del período'
}) {
  const list = Array.isArray(rows) ? rows : [];
  const max = list.reduce((n, r) => Math.max(n, r.count || 0), 0) || 1;

  return (
    <section className="analytics-cohort-states" aria-label={title}>
      <div className="analytics-cohort-states-head">
        <h2 className="analytics-cohort-h2">{title}</h2>
        <p className="analytics-cohort-note">{note}</p>
      </div>
      {!list.length ? (
        <p className="analytics-empty">Sin leads en el universo filtrado.</p>
      ) : (
        <ul className="analytics-cohort-state-list">
          {list.map((row) => {
            const pct = total ? Math.round((row.count / total) * 1000) / 10 : 0;
            const active = selectedId === row.id;
            return (
              <li key={row.id}>
                <button
                  type="button"
                  className={
                    'analytics-cohort-state-row' + (active ? ' is-active' : '')
                  }
                  onClick={() => onSelect(active ? '' : row.id)}
                >
                  <span className="analytics-cohort-state-name">{row.name}</span>
                  <span className="analytics-cohort-state-count">
                    {Number(row.count).toLocaleString('es-CL')}
                    <span className="analytics-cohort-state-pct">{pct}%</span>
                  </span>
                  <span
                    className="analytics-cohort-state-bar"
                    style={{ width: Math.max(4, (row.count / max) * 100) + '%' }}
                    aria-hidden
                  />
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
